import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import { StyledParagraph, StyledImageTag } from '../../../sharedComponents';
import { layoutTypes } from '../../constants';

import { Wrapper, Title } from './index.style';

export const TicketColumn = ({
  title,
  textBodyLeft,
  textBodyRight,
  alt,
  image,
  layout,
  index,
}) => {
  const themeConfig = useContext(ThemeContext);
  const vStyles = themeConfig.module.vStyles.elements.column;

  return (
    <Wrapper index={index}>
      {title && <Title data-testid="ticket-column-title">{title}</Title>}
      {layout === layoutTypes.twoColumns && textBodyLeft && (
        <StyledParagraph
          content={textBodyLeft}
          testId="ticket-column-text-left"
        />
      )}
      {layout === layoutTypes.threeColumns &&
        (textBodyLeft || textBodyRight) && (
          <div className="row">
            {textBodyLeft && (
              <div className="col-xs-6">
                <StyledParagraph
                  content={textBodyLeft}
                  testId="ticket-column-text-left"
                />
              </div>
            )}
            {textBodyRight && (
              <div className="col-xs-6">
                <StyledParagraph
                  content={textBodyRight}
                  testId="ticket-column-text-right"
                />
              </div>
            )}
          </div>
        )}
      {image?.path && (
        <StyledImageTag
          src={image.path}
          alt={alt}
          visualStyles={vStyles}
          testId="ticket-column-image"
        />
      )}
    </Wrapper>
  );
};

TicketColumn.propTypes = {
  title: PropTypes.string,
  textBodyLeft: PropTypes.string,
  textBodyRight: PropTypes.string,
  alt: PropTypes.string,
  image: PropTypes.shape({
    path: PropTypes.string,
  }),
  layout: PropTypes.oneOf(Object.values(layoutTypes)).isRequired,
  index: PropTypes.number,
};
